import React from 'react';
import PropTypes from 'prop-types';
import { HideZoomModal } from './buttons';
import { virtualCueOptions } from '../../constants/images'

/**
 * @description
 * Class for a showing a modal questions on screen.
 *
 * @example
 * <ZoomLightbox image={image} />
 */
const ZoomLightbox = ({ image, deactivatePopup }) => {

	return (
		<div className={'lightbox'}>
			<div className={'lightbox-inner'}>
				<HideZoomModal deactivatePopup={deactivatePopup}/>
				<img src={virtualCueOptions[image]}/>
			</div>
		</div>
	)
}

ZoomLightbox.propTypes = {
	image: PropTypes.string,
	zoomOut: PropTypes.func
}

export default ZoomLightbox;
